import { ISymbolsHandler } from '../../getSymbolsChecks.types';

export const handlerStroke: ISymbolsHandler = (opts) => {
  const { text, index, symbolMatches } = opts;
  const crossTag = text.substring(index, index + 2);

  if (crossTag === '~~') {
    symbolMatches['~~'].push({
      start: index,
      end: index + 2,
    });
  }
};
